// StoreMetricDataPointSerializer
export type StoreMetricDataPoint = {
  date: string; // date in format YYYY-MM-DD
  value: number;
};

// StoreMetricDataSerializer
export type StoreMetricData = {
  total: number;
  data: StoreMetricDataPoint[];
};

// StoreMetricDataCumulativeSerializer
export type StoreMetricDataCumulative = StoreMetricData & {
  total_cumulative: number;
};

// StoreMetricsSerializer
export type StoreMetrics = {
  published_count: StoreMetricData;
  orders_count: StoreMetricData;
  orders_pack_count: StoreMetricData;
  orders_total_sum: StoreMetricData;
  orders_total_avg: StoreMetricData;
  published_sold_percentage: StoreMetricData;
  co2_emissions_sum: StoreMetricDataCumulative;
};

// StorePackMetricSerializer
export type StorePackMetric = {
  id: number;
  name: string;
  quantity_sum: number;
  total_sum: number;
};

export enum StorePackMetricField {
  quantity_sum = 'quantity_sum',
  total_sum = 'total_sum',
}

// CategoryMetricSerializer
type CategoryMetric = {
  top: number;
  average: number;
};

// CategoryPackMetricSerializer
export type CategoryPackMetric = {
  name: string;
};

// CategoryMetricsSerializer
export type CategoryMetrics = {
  published_count: CategoryMetric;
  orders_count: CategoryMetric;
  orders_pack_count: CategoryMetric;
  orders_total_sum: CategoryMetric;
  orders_total_avg: CategoryMetric;
  published_sold_percentage: CategoryMetric;
  co2_emissions_sum: CategoryMetric;
  packs: CategoryPackMetric[];
};
